
<template>
<div>
    <footer class="footer sm:footer-horizontal footer-center bg-base-300 text-base-content py-5">
        <aside>
            <p>Copyright © {{ new Date().getFullYear() }} - All right reserved by Aanza</p>
        </aside>
    </footer>
</div>
</template>
